import React from "react";
import { observer } from "mobx-react-lite";
import { StatisticsGroups } from "@data-types/offer/event/EventViewStoreEnums";
import { useOfferContext } from "@state/hooks/offer/useOfferContext";
import { OfferStore } from "@state/context/offer/OfferContext";
import { getCurrentCulture } from "@utils";

export const FullStatistics = observer(function FullStatistics() {
	const store = useOfferContext<OfferStore.EventViewStore>();

	if (!store.sportStatisticsStore.betRadarStats) {
		return null;
	}

	const srcUrl = `https://s5.sir.sportradar.com/tipwin/${getCurrentCulture()}${`/match/${store.sportStatisticsStore.betRadarStats}`}`;

	if (store?.displayStatisticsGroup === StatisticsGroups.FullStats) {
		return (
			<div className="statistics--full-stats u-padd--reset">
				<iframe
					id="statistics-frame"
					className="popup--full__iframe"
					src={srcUrl}
				/>
			</div>
		);
	}

	return null;
});
